import { render } from "./typeServiceComponent.vue?vue&type=template&id=3be4157b"
import script from "./typeServiceComponent.vue?vue&type=script&lang=js"
export * from "./typeServiceComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__